<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="searchDate" :format="getDefaultDateFormat"
                    allowClear />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Petty Cash List" :manifestLink="getManifestLink" :dataList="searching"
        :price="true" :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "kaskecil",
  props: ["prnMenu"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      searchDate: null,
      search: "",
      status: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getStandartFormatDate);
        outputData = _.filter(outputData, { tgl_buat: filter });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (
        localStorage.getItem("nvpn") === "/keuangan" ||
        localStorage.getItem("nvpn") === "/keuangan/SpclKasKecil"
      ) {
        return "SpclKasKecilManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclKasKecilManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclKasKecilManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclKasKecilManifestDir";
      } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
        return "SpclKasKecilManifestVP";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclKasKecilManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclKasKecilManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclKasKecilManifestFin";
      } else {
        return "kaskecilmanifest";
      }
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/kas_kecil",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("nvky"),
          jenis: "Laporan",
          pimpro_sts: "Pimpro",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        _.forEach(response.data.data, (data) => {
          this.dataList.push({
            title: data.no_kas,
            timeline: JSON.parse(data.status_app),
            unread: data.unread == "1" ? true : false,
            subdesc: {
              pembuat: data.tlc,
              tanggal: moment(data.tgl_buat).format(this.getDefaultDateFormat),
              price: this.formatCurrency(data.currency, data.grand_total),
            },
            status: data.status,
            id: data.id_kas,
            price: data.grand_total,
            cancelStatus: data.cancel_sts,
            tgl_buat: data.tgl_buat,
            searchQ: data.no_kas + " " + data.tlc_pembuat + " " + data.tlc,
          });
        });

        this.loading = false;
      });
    },
  },
};
</script>

<style></style>